export const GET_FIRST_SYMPTOM_SUCCESS = 'GET_FIRST_SYMPTOM_SUCCESS'
export const GET_FIRST_SYMPTOM_FAIL = 'GET_FIRST_SYMPTOM_FAIL'
export const GET_FIRST_SYMPTOM_CLEAR_DATA = 'GET_FIRST_SYMPTOM_CLEAR_DATA'
